import Grid from "@mui/material/Grid";
import { Box, Stack } from "@mui/material";
import { LabelTemplate } from "./styles/table";
import { Employee } from "../types/processTypes";

import { BasicPostAppliedEnglishOnly } from "./components/basic/BasicPostApplied";
import { BasicDetailEnglish } from "./components/basic/BasicDetail";
import { BasicLanguageInayaEnglishOnly } from "./components/basic/BasicLanguage";
import { BasicExperienceEnglish } from "./components/basic/BasicExperience";
import { BasicSkillsEnglishOnly } from "./components/basic/BasicSkills";
import { BasicPassportEnglish } from "./components/basic/BasicPassport";
import { BasicFaceNoBorder } from "./components/basic/BasicFace";
import { BasicStandNoBorder } from "./components/basic/BasicStand";
import { BasicRemarksBullets } from "./components/basic/BasicRemarks";
import { BasicPassportScan } from "./components/basic/BasicPassportScan";
import { BasicHeaderNoBorder } from "./components/basic/BasicHeader";
import { Company } from "../../setups/types/setupTypes";
import { BasicTitleSingleLangSmaller } from "./components/basic/BasicTitle";

interface Props {
  selectedCompany: Company;
  currentEmployee: Employee;
  backgroundColor: string;
  cvTemplate: LabelTemplate;
}
function HomeTemplate({
  selectedCompany,
  currentEmployee,
  backgroundColor,
  cvTemplate,
}: Props) {
  //a08745;f2f1f0 fffcf2
  const lineTemplate = {
    ...cvTemplate,
    showCellBorders: true,
  };
  // bodyHeight: 34,
  // headerHeight: 36,
  // labelFontSize: 14,
  // valueFontSize: 14,

  return (
    <>
      <Box id="personalData" sx={{ p: 1 }}>
        <Grid
          container
          spacing={cvTemplate.spacing}
          sx={{
            p: 1,
            backgroundColor: backgroundColor,
            "& .MuiTable-root tbody tr td:nth-of-type(2), & .MuiTable-root tbody tr td:nth-of-type(3)":
              {
                textAlign: "center",
              },
          }}
        >
          <Grid
            item
            xs={12}
            sx={{
              height: "90%",
              mb: 1,
            }}
          >
            {cvTemplate && currentEmployee && (
              <BasicHeaderNoBorder
                selectedCompany={selectedCompany}
                currentEmployee={currentEmployee}
                template={cvTemplate}
              />
            )}
          </Grid>
          <Grid container item xs={12} spacing={cvTemplate.spacing}>
            <Grid item md={9} xs={12}>
              <Grid container spacing={cvTemplate.spacing}>
                <Grid item xs={12} md={6}>
                  {cvTemplate && currentEmployee && (
                    <Stack spacing={cvTemplate.spacing}>
                      <BasicTitleSingleLangSmaller template={lineTemplate} />
                      <BasicPostAppliedEnglishOnly
                        currentEmployee={currentEmployee}
                        template={lineTemplate}
                        showHeader={false}
                        showReferenceNumber={true}
                        showProfession={true}
                        showSalary={true}
                        showContractPeriod={true}
                      />
                    </Stack>
                  )}
                </Grid>
                <Grid item xs={12} md={6}>
                  {cvTemplate && currentEmployee && (
                    <BasicPassportEnglish
                      currentEmployee={currentEmployee}
                      template={lineTemplate}
                      showHeader={true}
                      showPassportNumber={true}
                      showIssueDate={true}
                      showPlaceOfIssue={true}
                      showExpiryDate={true}
                    />
                  )}
                </Grid>
              </Grid>
            </Grid>
            <Grid item md={3} xs={12}>
              {cvTemplate && currentEmployee && (
                <BasicFaceNoBorder
                  currentEmployee={currentEmployee}
                  template={{
                    ...cvTemplate,
                  }}
                />
              )}
            </Grid>
          </Grid>
          <Grid item md={6} xs={12}>
            {cvTemplate && currentEmployee && (
              <>
                <BasicDetailEnglish
                  currentEmployee={currentEmployee}
                  template={lineTemplate}
                  showHeader={true}
                  showName={true}
                  showReference={false}
                  showNationality={true}
                  showPassportNumber={false}
                  showReligion={true}
                  showDateOfBirth={true}
                  showAge={true}
                  showPlaceOfBirth={true}
                  showMaritalStatus={true}
                  showNumberOfChildren={true}
                  showWeightHeight={true}
                  showComplexion={true}
                  showEducation={true}
                  showLivingTown={false}
                  showEmployeeTelephone={true}
                  showContactName={false}
                  showContactTelephone={false}
                />

                <BasicLanguageInayaEnglishOnly
                  currentEmployee={currentEmployee}
                  template={lineTemplate}
                />

                <BasicExperienceEnglish
                  currentEmployee={currentEmployee}
                  template={lineTemplate}
                  type="basic"
                />
              </>
            )}
          </Grid>
          <Grid item md={6} xs={12}>
            {cvTemplate && currentEmployee && (
              <Stack
                spacing={cvTemplate.spacing}
                sx={{
                  alignItems: "center",
                }}
              >
                <BasicStandNoBorder
                  currentEmployee={currentEmployee}
                  template={{ ...cvTemplate }}
                />
              </Stack>
            )}
          </Grid>
          <Grid item md={6} xs={12}>
            <BasicSkillsEnglishOnly
              currentEmployee={currentEmployee}
              template={lineTemplate}
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <BasicRemarksBullets
              currentEmployee={currentEmployee}
              template={lineTemplate}
            />
            {/* <BasicRemarksConfidential
              currentEmployee={currentEmployee}
              template={lineTemplate}
            /> */}
          </Grid>
        </Grid>
      </Box>
      {cvTemplate.numberOfPages === 2 && (
        <Stack
          id="passportData"
          sx={{
            p: 1,
            pt: 1,
            backgroundColor: backgroundColor,
            minHeight: "1500px",
          }}
        >
          {cvTemplate.addPassportHeader && (
            <Box
              sx={{
                height: "90%",
              }}
            >
              {cvTemplate && currentEmployee && (
                <BasicHeaderNoBorder
                  selectedCompany={selectedCompany}
                  currentEmployee={currentEmployee}
                  template={cvTemplate}
                />
              )}
            </Box>
          )}
          {cvTemplate && currentEmployee && (
            <Box
              sx={{
                mt: 15,
              }}
            >
              <BasicPassportScan
                currentEmployee={currentEmployee}
                template={cvTemplate}
              />
            </Box>
          )}
        </Stack>
      )}
    </>
  );
}

export default HomeTemplate;
